<fc-modal [id]="modalId" [options]="options">
    <div class="fc-modal-content fc-request-with-note-modal-content">
        <h3 class="fc-request-with-note-modal-header">
            {{ 'ORDER.BRAND_OVERVIEW.REQUEST_ACCESS_MODAL_HEADER' | translate }}
        </h3>
        <div class="fc-request-with-note-modal-separator"></div>

        <div class="fc-request-with-note-modal-body">
            <div class="fc-request-with-note-modal-data">
                <div class="fc-request-with-note-modal-label fcp-text-body-l">
                    {{ 'ORDER.BRAND_OVERVIEW.REQUEST_ACCESS_MODAL_MESSAGE' | translate }}
                </div>
                <textarea
                    class="fc-request-with-note-modal-message"
                    placeholder="{{ 'ORDER.BRAND_OVERVIEW.REQUEST_ACCESS_MODAL_MESSAGE_PLACEHOLDER' | translate }}"
                    #messageText
                    [ngModel]=""
                    [ngModelOptions]="{ updateOn: 'change' }"
                    [value]="message"
                    (input)="updateMessage(messageText.value)"
                    [maxlength]="500"
                    data-e2e-hook="brand-discovery-request-access-modal-input"
                ></textarea>

                <div *ngIf="showVat | async">
                    <div class="fc-request-with-note-modal-label fcp-text-body-l">
                        {{ 'ORDER.BRAND_OVERVIEW.REQUEST_ACCESS_MODAL_VAT_TITLE' | translate }}
                    </div>
                    <input
                        class="fc-request-with-note-modal-vat"
                        placeholder="{{ 'ORDER.BRAND_OVERVIEW.REQUEST_ACCESS_MODAL_VAT_PLACEHOLDER' | translate }}"
                        #vatText
                        [value]="vat"
                        (input)="updateVat(vatText.value)"
                        data-e2e-hook="brand-discovery-request-access-modal-vat"
                    />
                </div>

                @if (enableRetailerTerms) {
                    <div class="fc-request-with-note-modal-retailer-terms">
                        @let termsFile = retailerTermsFile | async;
                        @if (termsFile) {
                            <div>
                                <fcp-icon [icon]="['far', 'file-pdf']"></fcp-icon>
                                <span>{{ termsFile.filename }}.{{ termsFile.extension }}</span>
                                <ng-container *ngTemplateOutlet="tooltip"></ng-container>
                                <span class="remove-button" (click)="deselect()">{{
                                    'REQUEST_ACCESS_MODAL.RETAILER_TERMS.REMOVE_FILE' | translate
                                }}</span>
                            </div>
                        } @else {
                            <label data-e2e-hook="add-terms-and-conditions-here">
                                <fcp-icon [icon]="['far', 'cloud-arrow-up']"></fcp-icon>
                                <span class="upload-label">{{
                                    'REQUEST_ACCESS_MODAL.RETAILER_TERMS.UPLOAD_LABEL' | translate
                                }}</span>
                                <input type="file" accept="application/pdf" (change)="selectFile($event)" />
                                <ng-container *ngTemplateOutlet="tooltip"></ng-container>
                                <span class="description">{{
                                    'REQUEST_ACCESS_MODAL.RETAILER_TERMS.UPLOAD_DESCRIPTION' | translate
                                }}</span>
                            </label>
                        }
                    </div>
                }
            </div>

            <ng-template #tooltip>
                <fcp-icon
                    class="tooltip"
                    [icon]="'info-circle'"
                    cdkOverlayOrigin
                    (mouseenter)="retailerTermsTooltipOpen = true"
                    (mouseleave)="retailerTermsTooltipOpen = false"
                    #informationIcon="cdkOverlayOrigin"
                ></fcp-icon>
                <fcp-tooltip
                    [open]="retailerTermsTooltipOpen"
                    [overlayOrigin]="informationIcon"
                    [customPosition]="tooltipPosition"
                >
                    <span>
                        {{ 'REQUEST_ACCESS_MODAL.RETAILER_TERMS.UPLOAD_TOOLTIP' | translate }}
                    </span>
                </fcp-tooltip>
            </ng-template>

            <div class="fc-request-with-note-modal-brand-terms" *ngIf="requestedProductTerms?.length > 0">
                <fcp-checkbox [checked]="brandTermsAccepted" (change)="setBrandTermsAccepted($event)">
                    <span>{{ 'REQUEST_ACCESS_MODAL.BRAND_TERMS.I_AGREE' | translate }}</span>
                    <span *ngFor="let fcProduct of requestedProductTerms; let i = index">
                        <span *ngIf="i !== 0"> & </span>
                        <a [href]="fcProduct.pdfLink" class="fc-request-with-note-modal-brand-terms-item">
                            {{ fcProduct.pdfLinkTranslationKey | translate }}
                        </a>
                    </span>
                </fcp-checkbox>
            </div>
        </div>

        <div class="fc-request-with-note-modal-footer">
            <button
                fcp-outlined-button
                text=""
                (click)="reject.emit(); close()"
                [attr.data-e2e-hook]="'brand-discovery-request-access-modal-cancel'"
            >
                {{ 'TEXT_CANCEL' | translate }}
            </button>

            <button
                fcp-button
                (click)="requestAccess(); close()"
                [attr.data-e2e-hook]="'brand-discovery-request-access-modal-send'"
                [disabled]="(!brandTermsAccepted && requestedProductTerms?.length > 0) || ((showVat | async) && !vat)"
            >
                {{ 'ORDER.BRAND_OVERVIEW.REQUEST_ACCESS_MODAL_BUTTON_TEXT' | translate }}
            </button>
        </div>
    </div>
</fc-modal>
